import React from "react";
import abImg from "../../images/about/img-1.jpg";
import abImg2 from "../../images/about/img-2.jpg";
import abImg3 from "../../images/about/icon.png";
import Logo from "../UiStyle/Logo";

const About = (props) => {
  return (
    <section className="about-section separator-padding bg-black text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="about-img-wrap">
              <div className="about-img-top">
                <img src={"https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731328575527_551245799.png"} alt="" />
              </div>
              <div className="about-img-bottom">
                <img src={"https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731322117652_230206230.png"} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-text">
              <div className="about-icon">
                <Logo className="h-35" />
              </div>
              <h2 className="text-white">
  Epayworld – Your destination for instant mobile top-ups, global eSIMs, and exclusive gift cards
</h2>
<p>
  Epayworld is a trusted global platform for seamless mobile recharge, eSIM activation, and digital gift card purchases. We offer an extensive selection of eGift cards from leading brands such as Walmart, Steam, Uber & Uber Eats, Amazon, Google Play, Sony PlayStation, PUBG, The Ultimate Dining Card, Winners, and more. 
  <br /><br />
  With over a hundred digital voucher options across multiple countries and denominations, Epayworld ensures fast, secure delivery and a hassle-free gifting experience. Whether you're topping up your phone or sending a thoughtful eGift, Epayworld has everything you need — instantly and worldwide.
</p>


              <p style={{ color: "grey", opacity: "0.8" }}>(epayworld.me is owned by E Payments Services LLC, registered in UAE).</p>
              {/* <div className="row">
                                <div className="col-sm-6">
                                    <div className="about-features">
                                        <i className="icon-medical"></i>
                                        <h3>User</h3>
                                        <p>I've been a loyal customer of Epayworld for years, and their gift cards and exclusive deals always exceed my expectations! .</p>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="about-features">
                                        <i className="icon-medicine"></i>
                                        <h3>Gifts</h3>
                                        <p>I've been a loyal customer of Epayworld for years, and their gift cards and exclusive deals always exceed my expectations!</p>
                                    </div>
                                </div>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
